import { createTheme } from "@mui/material/styles";

export const getDesignTokens = (mode) => {
  const customPalettes = {
    light: {
      background: { main: "#13110f" },
      fieldFill: { main: "#25211c" },
      button: { main: "#ffc862" },
      button2: { main: "#ffa046" },
      defultText: { main: "#987b3e" },
      white: { main: "#ffffff" },
      white50: { main: "#ffffff80" },
      error: { main: "#FF5050" },
      black: { main: "#000000" },
    },
  };

  const palette = customPalettes[mode];
  if (palette) {
    Object.entries(palette).forEach(([key, value]) => {
      document.documentElement.style.setProperty(`--${key}`, value.main);
    });
  }

  return createTheme({
    palette: {
      mode: "light",
      ...palette,
    },
    typography: {
      fontFamily: "IRANSANSWEB",
      fontSize: 16,
      h1: {
        fontSize: "2.5rem",
        fontWeight: 900,
      },
      h2: {
        fontSize: "2rem",
        fontWeight: 700,
      },
      h3: {
        fontSize: "1.75rem",
        fontWeight: 600,
      },
      h4: {
        fontSize: "1.5rem",
        fontWeight: 600,
      },
      h5: {
        fontSize: "1.2rem",
        fontWeight: 500,
      },
      h6: {
        fontSize: "1rem",
        fontWeight: 400,
      },
      p: {
        fontFamily: "IRANSANSWEB",
        fontSize: "0.9rem",
      },
    },
    customMode: mode,
  });
};
